import React, {useEffect} from "react";
import {inject, observer} from "mobx-react";

import {trans} from "../../../../common/utils";
import {LLBtn2} from "../../../../components";


const FirstPopup = ({
                        store,
                    }) => {

    const viewSize = store.site.status.viewSize,
        setTutorialStep = store.slotsBattles.setTutorialStep,
        isBackdropShown = store.site.status.isBackdropShown,
        setBackdropShown = store.site.status.setBackdropShown,
        setBackDropClosable = store.site.status.setBackDropClosable,
        setBackdropOnClick = store.site.status.setBackdropOnClick,
        setBackDropFullScreen = store.site.status.setBackDropFullScreen,
        userBattleId = store.user.userBattleId,
        router = store.router;

    useEffect(() => {
        if (!isBackdropShown) {
            setBackdropShown(true);
            setBackDropClosable(false);
            setBackdropOnClick(() => {});
            setBackDropFullScreen(true);
        }
    }, [isBackdropShown])

    useEffect(() => () => setBackdropShown(false), [])

    return (
        <div className={`battle-tutorial battle-tutorial--${viewSize}`}>
            <div className="battle-tutorial__content">
                <p>{trans('SLOT_BATTLE__TUTORIAL_STEP_2_TEXT')}</p>
            </div>
            <div className="battle-tutorial__buttons">
                <LLBtn2
                    onClick={() => {
                        router.push(`/slots/slots-battles/${userBattleId ?? 'create'}`);
                        setTutorialStep(userBattleId ? 3 : 2);
                    }}
                    customClasses="slots-battles__btn--accent"
                >
                    {trans("Ok")}
                </LLBtn2>
            </div>
        </div>
    );
};

export default inject('store')(observer(FirstPopup));